import {AnswerValueTypes,BasicAnswerSave} from "@/state/survey/saveAnswerSlice";
import {FormState} from "../types/commonTypes";
import {INode} from "../types/nodeTypes";

const answerDetails = (function () {

    const isBasicAnswerSaveArray = (obj: any): obj is BasicAnswerSave[] => {
        return (
            Array.isArray(obj) &&
            obj.every(
                (item) =>
                    typeof item.name === 'string' &&
                    'value' in item 
            )
        );
    }

    const setNameAndValue = (node: INode, form: FormState) => {
        const answerObject: BasicAnswerSave = {
            name: node.name,
            value: form[node.name]?.value as unknown as AnswerValueTypes
        }
        const answers : BasicAnswerSave[] = []
        answers.push(answerObject)
        return answers;
    }

    const setNameAndValueFromDirectValue = (node: INode, value: unknown | AnswerValueTypes) => {
        const answerObject: BasicAnswerSave = {
            name: node.name,
            value: value as unknown as AnswerValueTypes
        }
        const answers : BasicAnswerSave[] = []
        answers.push(answerObject)
        return answers;
    }
    
    



    return {
        isBasicAnswerSaveArray: isBasicAnswerSaveArray,
        setNameAndValueFromDirectValue: setNameAndValueFromDirectValue,
        setNameAndValue: setNameAndValue
    }
})()

export default answerDetails
